import Vue from "vue";
import {CancelToken} from "axios";
import validatePop from "@/plugins/validatePop.js";
const vm = new Vue();
const TIME = 500;
let source;
let setTime;

export const searchSenderDetails = (value) => {
  let _SELF = vm;
  if (source) {
    source.cancel();
  }
  source = CancelToken.source();
  const cancelToken = source.token;
  return new Promise((resolve) => {
    if (value.length < 3) {
      return resolve([]);
    }
    if (isNaN(value)) {
      return resolve([]);
    }
    clearTimeout(setTime);
    setTime = setTimeout(function() {
      _SELF.$http
        .get(_SELF.$API_URL + "/sender/" + value + "/details", {
          cancelToken,
          headers: {Token: localStorage.getItem("access_token")},
        })
        .then((res) => {
          let data = res.data.data;
          if (data === "data not found") {
            resolve([]);
          } else {
            resolve(data);
          }
        })
        .catch(() => {});
    }, TIME);
  });
};

export const searchRecipientDetails = (value) => {
  let _SELF = vm;
  if (source) {
    source.cancel();
  }
  source = CancelToken.source();
  const cancelToken = source.token;
  return new Promise((resolve) => {
    if (value.length < 3) {
      return resolve([]);
    }
    clearTimeout(setTime);
    setTime = setTimeout(function() {
      _SELF.$http
        .post(
          _SELF.$API_URL + "/recipientDetails",
          {search: value},
          {
            cancelToken,
            headers: {Token: localStorage.getItem("access_token")},
          }
        )
        .then((res) => {
          let data = res.data.data;
          if (data === "data not found") {
            resolve([]);
          } else {
            resolve(data);
          }
        })
        .catch(() => {});
    }, TIME);
  });
};

export const focusOutRecipientDetails = () => {
  source.cancel();
};

export const getValueRecipientDetails = (result) => {
  return result;
};

export const searchRecipientDetailsInter = (value) => {
  let _SELF = vm;
  if (source) {
    source.cancel();
  }
  source = CancelToken.source();
  const cancelToken = source.token;
  return new Promise((resolve) => {
    if (value.length < 3) {
      return resolve([]);
    }
    clearTimeout(setTime);
    setTime = setTimeout(function() {
      _SELF.$http
        .post(
          _SELF.$API_URL + "/recipientDetails/inter",
          {search: value},
          {
            cancelToken,
            headers: {Token: localStorage.getItem("access_token")},
          }
        )
        .then((res) => {
          let data = res.data.data;
          if (data === "data not found") {
            resolve([]);
          } else {
            resolve(data);
          }
        })
        .catch(() => {});
    }, TIME);
  });
};

export const getValueRecipientDetailsInter = (result) => {
  return result;
};

export const searchTrackingDropoff = async (tracking_code, dropoff = false) => {
  return new Promise((resolve, reject) => {
    vm.$http
      .post(
        vm.$API_URL + "/dropoff/shipment",
        {
          tracking_code: tracking_code,
          ...(dropoff ? {dropoff: dropoff} : {}),
        },
        {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        }
      )
      .then((res) => {
        let checkError = validatePop(res);
        if (!checkError.status) {
          reject(checkError.msg);
        }
        resolve(res.data.data);
      });
  });
};

export const searchTrackingKerryDropoff = async (tracking_code) => {
  return new Promise((resolve, reject) => {
    vm.$http
      .get(vm.$API_URL + "/dropoff/kerry/shipment", {
        headers: {
          Token: localStorage.getItem("access_token"),
        },
        params: {
          tracking_code: tracking_code,
        },
      })
      .then((res) => {
        let checkError = validatePop(res);
        if (!checkError.status) {
          reject(checkError.msg);
        }
        resolve(tracking_code);
      });
  });
};

export const searchTrackingFlashDropoff = async (payload) => {
  return new Promise((resolve, reject) => {
    vm.$http.get(vm.$API_URL + "/dropoff/flash/shipment", {
      headers: {
        Token: localStorage.getItem("access_token")
      },
      params: {
        tracking_code: payload.tracking_code,
        query_id: payload.query_id,
        parcel: {
          weight: payload.parcel.weight,
          width: payload.parcel.width,
          length: payload.parcel.length,
          height: payload.parcel.height
        }
      }
    })
    .then((res) => {
      let checkError = validatePop(res)
      if (!checkError.status) {
        reject(checkError.msg)
      }

      const { data } = res.data

      const response = {
        tracking_code: data.pre_barcode,
        query_id: data.query_id,
        parcel: {
          weight: data.parcel.weight,
          width: data.parcel.width,
          length: data.parcel.length,
          height: data.parcel.height
        },
        message: data.message
      }

      resolve(response)
    })
  })
}

export const searchTrackingLazadaDropoff = async (tracking_code) => {
  return new Promise((resolve, reject) => {
    vm.$http
      .get(vm.$API_URL + "/dropoff/lazada/shipment", {
        headers: {
          Token: localStorage.getItem("access_token"),
        },
        params: {
          tracking_code: tracking_code,
        },
      })
      .then((res) => {
        let checkError = validatePop(res);
        if (!checkError.status) {
          reject(checkError.msg);
        }
        resolve(tracking_code);
      });
  });
};
